<template>
    <section-con main="用科技驱动教育进步" sub="我们重新定义科教 科教重新定义未来">
       <div class="love-learn">
           <div class="love-learn-item" v-for="(item, index) in aiLoveLearnList" :key="index">
               <img class="learn-img" :src="item.img">
               <p class="des">{{item.des}}</p>
           </div>
       </div>
    </section-con>
</template>
<script>
import { aiLoveLearnList } from '@/const'
export default {
    data () {
        return {
            aiLoveLearnList: aiLoveLearnList
        }
    }
}
</script>
<style lang="scss" scoped>
.love-learn{
    padding: 0px 10px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .love-learn-item{
        margin-right: 10px;
        margin-bottom: 10px;
        width: 162px;
        background:rgba(255,255,255,1);
        box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
        border-radius:4px;
        .learn-img{
            width: 100%;
        }
        .des{
            text-align: left;
            padding: 10px 0px 9px 10px;
            font-size:12px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:#282828;
            line-height:17px;
            text-shadow:0px 5px 12px rgba(147,147,147,0.14);
        }
    }
}
</style>